import React from "react";
import { Col } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";
import { backgroundImageStyle, imageUrl } from "./backgroundImageStyle";
import { BiLink } from "lib/routing";
import ErrorBoundary from "lib/ErrorBoundary";
import useIsMobile from "lib/hooks/useIsMobile";
import { SmallWhiteNomuraLogo, Heading, Title, Text, CenterImg, CenterButton, Footer } from "./AdvertCardParts";
import { auditAdvertClick } from "lib/analytics/auditEvents";
import { useSelector } from "react-redux";
import { getAdvertStyles, classes } from "./getAdvertStyles";
import { AdvertCard2 } from "./AdvertCard2";

export const AdvertCard = ({ ...advert }) => {
  let legacyStyles = useSelector((state) => state.misc.advertStyles) || {};
  const isMobile = useIsMobile();
  if (isMobile) advert = toMobileFields(advert);
  advert = replaceAdvertLineBreaks(advert, isMobile);

  const styles = getAdvertStyles(advert, legacyStyles);
  advert.styles = styles;

  if (advert.advert_version === "2" && advert.style_json_text) return <AdvertCard2 advert={advert} />;

  return (
    <ErrorBoundary>
      <section
        className={`${classes.card} ${styles.card} ${styles.padding}`}
        style={{ ...backgroundImageStyle(advert), ...styles.cardStyle }}
      >
        <HRow advert={advert} />
      </section>
    </ErrorBoundary>
  );
};

export const HRow = ({ advert }) => (
  <BiLink id="row" to={advert.url} onClick={auditAdvertClick(advert)} className={`${classes.row} ${advert.styles.row}`}>
    <LHS {...advert} />
    <Center {...advert} />
    <RHS {...advert} />
  </BiLink>
);

const LHS = ({ leftImg, leftIcon, styles }) =>
  leftImg ? (
    <img src={imageUrl(leftImg)} className={styles.leftImg} alt="advert icon" style={styles.leftImgStyle} />
  ) : leftIcon ? (
    <FaIcon icon={leftIcon} />
  ) : null;

const Center = (advert) => (
  <div id="center-col" className={advert.styles.body} style={advert.styles.bodyStyle}>
    <SmallWhiteNomuraLogo {...advert} />
    <Heading {...advert} />
    <Title {...advert} />
    <Text {...advert} />
    <CenterImg {...advert} />
    <CenterButton {...advert} />
    <Footer {...advert} />
  </div>
);

const RHS = ({ rightImg, rightIcon, rightNomuraLogo, rightButton, styles }) => (
  <section className={styles.rhs} style={styles.rhsStyle}>
    {rightNomuraLogo && <SmallWhiteNomuraLogo nomuraLogo={rightNomuraLogo} />}
    {rightImg && (
      <img src={imageUrl(rightImg)} className={styles.rightImg} style={styles.rightImgStyle} alt="advert icon" />
    )}
    {rightIcon && <FaIcon icon={rightIcon} />}
    {rightButton && <CenterButton button={rightButton} styles={styles} />}
  </section>
);

const toMobileFields = (advert) => {
  advert.isMobile = true;
  advert.img = advert.mobileImg || advert.img;
  advert.heading = advert.mobileHeading || advert.heading;
  advert.title = advert.mobileTitle || advert.title;
  advert.footer = advert.mobileFooter || advert.footer;
  return advert;
};

const replaceAdvertLineBreaks = (advert, isMobile) => {
  const render = isMobile ? mobileLineBreak : removeLineBreak;
  advert.header = render(advert.header);
  advert.title = render(advert.title);
  advert.footer = render(advert.footer);
  return advert;
};

const mobileLineBreak = (string) => (string ? string.replace(/\r[・、＆&]?/g, "\n") : undefined);
const removeLineBreak = (string) => (string ? string.replace(/\r/g, "") : undefined);

// called by TileView.js for ads in tiles
export const AdvertCardCol = (advert) => (
  <Col lg={4} md={6} className="d-flex pb-3 px-2">
    <AdvertCard {...advert} />
  </Col>
);
